export default __webpack_public_path__ + "static/media/yogaImg.efd00364.jpg";